module.exports = __webpack_public_path__ + "img/smartintrade-logo-new.da591785.png";